import { render } from "./templates.vue?vue&type=template&id=a5bf7180&lang=html"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"

import "./templates.vue?vue&type=style&index=0&id=a5bf7180&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__